import { useTitleChange } from '@msaf/core-react'
import HistorySearch from '../../../../components/well-forms/history/search'

export default function EditWellHistory() {
  useTitleChange('Edit Well | History')
  return <HistorySearch />
}
